import {GenerateWidgetEvent} from '@projectstorm/react-canvas-core'
import {JSX} from 'react'
import {NodeTypeEnum} from '../../../../types/NodeTypeEnum'
import {CustomNodeFactory} from '../CustomNodeFactory'
import {CustomNodeModel} from '../CustomNodeModel'
import {VariantNodeModel} from './VariantNodeModel'
import {VariantNodeWidget} from './VariantNodeWidget'

export class VariantNodeFactory extends CustomNodeFactory {
  constructor() {
    super(NodeTypeEnum.variant)
  }

  generateReactWidget(event: GenerateWidgetEvent<CustomNodeModel>): JSX.Element {
    return <VariantNodeWidget engine={this.engine} node={event.model} />
  }

  generateModel() {
    return new VariantNodeModel()
  }
}
